import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  max-width: ${props => props.theme.maxWidth};
  margin: auto;
  padding: 30px 0 60px;
  box-shadow: inset 2000px 0 0 0 rgba(255, 255, 255, 0.9);
  text-align: center;

  > div {
    padding: 0 60px;
    ${bp('sm')`
      padding: 0 30px;
    `}
  }

  h2 {
    ${props => props.theme.css.heading3};
  }

  .steps-images {
    display: flex;
    justify-content: space-around;
    max-width: 1200px;
    margin: 60px auto;
    color: ${props => props.theme.palette.primary.alphaDark};
    font: ${font('default', 'normal', '22px/1')};
    ${bp('sm')`
      font: ${font('default', 'normal', '18px/1')};
      flex-wrap: wrap;
    `}

    > div {
      height: 170px;
      margin: 10px;

      &,
      a {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
      }

      img {
        width: 100px;
        height: auto;
        margin-bottom: 10px;
      }

      p {
        margin: auto 0 0;
      }
    }
  }

  a {
    text-decoration: none;
    max-width: 350px;
    margin: auto;
    color: ${props => props.theme.palette.primary.alphaDark};
    height: 100%;
  }

  .button {
    padding: 15px 10px;
    max-width: 320px;
    border-radius: 10px;
    background: ${props => props.theme.palette.primary.beta};
    margin: auto;
    box-shadow: 0 2px 12px -4px rgba(0, 0, 0, 0.75);
    ${bp('sm')`
      max-width: 200px;
    `}

    p {
      font: ${font('default', 'bold', '20px/1.4')};
      text-transform: uppercase;
      letter-spacing: 1px;
      color: ${props => props.theme.palette.general.light};
      margin: 0;
      ${bp('sm')`
        font: ${font('default', 'bold', '16px/1.4')};
      `}
    }
  }
`
